// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + "main" + "." + "87506c1d6c3b21b1d68a" + ".css";
};